import { RootState } from 'global/state';

export const getSidebarVisibility = (state: RootState) => state.ui.sidebarVisible;
